"use strict";

var _interopRequireDefault = require("C:/Users/sandy/Desktop/EIOSYS/Admin/Alembic-Grow-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getZMLocations = exports.defaultZMLocationData = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
const defaultZMLocationData = exports.defaultZMLocationData = {
  id: null,
  name: ''
};
const getZMLocations = params => (0, _request.default)({
  url: '/zm-locations',
  method: 'get',
  params
});
exports.getZMLocations = getZMLocations;